<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiGroup } from "@mdi/js";
export default {
  name: "MdiGroup",
  data() {
    return {
      svgPath: mdiGroup,
    };
  },
};
</script>
